enum FulfillmentStatus {
  CONFIRMED = 'confirmed',
  ACCEPTED = 'accepted',
  CANCELED = 'canceled',
  DELIVERED = 'delivered',
  PLACED = 'placed',
}
export default FulfillmentStatus;
